// @flow

import * as React from 'react';

import type { Contact } from '@gandi/domain-configuration';
import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { selectHasDomainTransfer } from '../../../../modules/selectors';

import SwitchIndicator from './SwitchIndicator';

import styles from './ContactPrivacyOptions.scss';

type Props = { contact: Contact };

const ContactPrivacyOptions = ({ contact }: Props): React.MixedElement => {
  const { __ } = useTranslator();
  const hasDomainTransfer = useAppSelector(selectHasDomainTransfer);

  return (
    <Base tagName="ul" listStyleType="none" margin="none" padding="none">
      <Base tagName="li" marginBottom="xsmall" flex flexAlignItemsCenter>
        <SwitchIndicator enabled={contact.mail_obfuscated} />
        <span>{__('Email address hidden')}</span>
      </Base>

      <Base tagName="li" marginBottom="xsmall" flex flexAlignItemsCenter>
        <SwitchIndicator enabled={contact.data_obfuscated} />
        <span>{__('Whois privacy enabled')}</span>
      </Base>
      {hasDomainTransfer && (
        <Base tagName="li" flex flexAlignItemsCenter>
          <SwitchIndicator enabled={contact.send_invitation} />
          <span className={styles.resetLineHeight}>
            {__('Managing contact invited')}
          </span>
        </Base>
      )}
    </Base>
  );
};

export default (React.memo<Props>(
  ContactPrivacyOptions,
): React.ComponentType<Props>);
